import {
    AUTH_CHANGE_EMAIL,
    AUTH_CHANGE_PASSWORD,
    AUTH_CHANGE_REMEMBER,
    AUTH_CHANGE_RESET_PASSWORD,
    AUTH_CHANGE_RESET_PASSWORD_REPEAT,
    AUTH_LOGIN_ERROR,
    AUTH_LOGIN_LOADING,
    AUTH_LOGIN_SUCCESS,
    AUTH_LOGIN_UPDATE,
    AUTH_LOGIN_USER,
    AUTH_REMEMBER_PASSWORD_ERROR,
    AUTH_REMEMBER_PASSWORD_LOADING,
    AUTH_RESET_PASSWORD_ERROR,
    AUTH_RESET_PASSWORD_LOADING,
} from '../actions/authActions';
import { CONTRACTORS } from '../../contractors/actions/contractorsActions';

const INITIAL_STATE = {
    email: '',
    password: '',
    remember: true,
    loading: false,
    error: '',
    loadingRememberPassword: false,
    errorRememberPassword: '',
    resetPassword: '',
    resetPasswordRepeat: '',
    loadingResetPassword: false,
    errorResetPassword: '',
    token: '',
    user: null,
    contractor: null,
    contractorLoading: false,
};

export default (state = INITIAL_STATE, action) => {
    switch ( action.type ) {
        case AUTH_LOGIN_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case AUTH_LOGIN_SUCCESS:
            return {
                ...state,
                token: action.payload,
            };
        case AUTH_LOGIN_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        case AUTH_LOGIN_USER:
            return {
                ...state,
                user: {
                    ...action.payload,
                },
            };
        case AUTH_LOGIN_UPDATE:
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.payload,
                },
            };
        case AUTH_CHANGE_EMAIL:
            return {
                ...state,
                email: action.payload,
                error: '',
            };
        case AUTH_CHANGE_PASSWORD:
            return {
                ...state,
                password: action.payload,
                error: '',
            };
        case AUTH_CHANGE_REMEMBER:
            return {
                ...state,
                remember: action.payload,
            };
        case AUTH_REMEMBER_PASSWORD_LOADING:
            return {
                ...state,
                loadingRememberPassword: action.payload,
            };
        case AUTH_REMEMBER_PASSWORD_ERROR:
            return {
                ...state,
                errorRememberPassword: action.payload,
            };
        case AUTH_CHANGE_RESET_PASSWORD:
            return {
                ...state,
                resetPassword: action.payload,
                errorResetPassword: '',
            };
        case AUTH_CHANGE_RESET_PASSWORD_REPEAT:
            return {
                ...state,
                resetPasswordRepeat: action.payload,
                errorResetPassword: '',
            };
        case AUTH_RESET_PASSWORD_LOADING:
            return {
                ...state,
                loadingResetPassword: action.payload,
            };
        case AUTH_RESET_PASSWORD_ERROR:
            return {
                ...state,
                errorResetPassword: action.payload,
            };
        // contractorsActions.js -> fetchContractorCurrent
        case CONTRACTORS.FETCH_CONTRACTOR_CURRENT_SUCCEED:
            return {
                ...state,
                contractor: action.payload.data,
            };
        case CONTRACTORS.FETCH_CONTRACTOR_CURRENT_LOADING:
            return {
                ...state,
                contractorLoading: action.payload,
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/app/login/reducer/AuthReducer.js